import { motion } from "framer-motion";
import { useInView } from "framer-motion";
import { useRef } from "react";
import { Building2, Cpu, GraduationCap, Heart, Landmark, ShoppingBag, Wrench, Sparkles } from "lucide-react";

const sectors = [
  { icon: Building2, label: "Consultoría B2B", color: "from-blue-500 to-cyan-500" },
  { icon: Cpu, label: "SaaS y Tecnología", color: "from-purple-500 to-blue-500" },
  { icon: Heart, label: "Salud y Bienestar", color: "from-pink-500 to-red-500" },
  { icon: Landmark, label: "Legal y Finanzas", color: "from-cyan-500 to-blue-500" },
  { icon: GraduationCap, label: "Formación y EdTech", color: "from-purple-500 to-pink-500" },
  { icon: ShoppingBag, label: "Retail y E-commerce", color: "from-blue-500 to-purple-500" },
  { icon: Wrench, label: "Industrial y Servicios", color: "from-pink-500 to-purple-500" },
  { icon: Sparkles, label: "Agencias y Creativos", color: "from-blue-500 to-pink-500" },
];

export default function Sectors() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <section className="section-spacing bg-white" data-testid="sectors-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" ref={ref}>
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={isInView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
          className="text-center mb-14"
        >
          <span className="inline-block text-xs uppercase tracking-[0.2em] text-galvani-blue font-body font-semibold mb-4">
            Sectores en los que trabajamos
          </span>
          <h2 className="font-heading font-extrabold text-3xl sm:text-4xl lg:text-5xl tracking-tight text-galvani-text mb-4">
            No importa tu <span className="gradient-text">nicho</span>, sabemos comunicarlo
          </h2>
          <p className="font-body text-galvani-textLight max-w-2xl mx-auto">
            Producimos podcasts para empresas de sectores muy distintos. Adaptamos el enfoque
            y el estilo a tu audiencia, no al revés.
          </p>
        </motion.div>

        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6">
          {sectors.map((s, i) => (
            <motion.div
              key={s.label}
              initial={{ opacity: 0, y: 30 }}
              animate={isInView ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              className="group p-6 rounded-2xl bg-white border border-slate-200 hover:shadow-lg hover:-translate-y-1 transition-all text-center"
            >
              <div className={`w-14 h-14 mx-auto rounded-xl bg-gradient-to-br ${s.color} flex items-center justify-center mb-4 group-hover:scale-110 transition-transform`}>
                <s.icon className="w-7 h-7 text-white" />
              </div>
              <h3 className="font-heading font-semibold text-sm md:text-base text-galvani-text">
                {s.label}
              </h3>
            </motion.div>
          ))}
        </div>

        <motion.p
          initial={{ opacity: 0 }}
          animate={isInView ? { opacity: 1 } : {}}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="mt-10 text-center text-sm text-galvani-textLight italic"
        >
          ¿No ves tu sector? Nos adaptamos. Cuéntanoslo y te decimos si podemos ayudarte.
        </motion.p>
      </div>
    </section>
  );
}
